import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import ActivitiesPosterSale from '@/types/table/activitiesPosterSale';
import { ActivitiesData } from '@/api/generated/activitiesController';
import { ActivitiesPosterData } from '@/api/generated/activitiesPosterController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface ActivitiesPosterSaleData extends ActivitiesPosterSale {
  activities?: ActivitiesData;
  activitiesPoster?: ActivitiesPosterData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class ActivitiesPosterSaleController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<ActivitiesPosterSaleData>>(API_CONTEXT + '/app/activitiesPosterSale/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<ActivitiesPosterSaleData>(API_CONTEXT + '/app/activitiesPosterSale/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/activitiesPosterSale/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/activitiesPosterSale/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/activitiesPosterSale/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/activitiesPosterSale/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/activitiesPosterSale/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/activitiesPosterSale/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/activitiesPosterSale/deleteBatch', params, httpOptions);
  }
}
